import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as reposReducer } from './repos';
import { reducer as skillsReducer } from './skills';
import { reducer as messageReducer } from './message';
import { reducer as loaderReducer } from './loader';
import { reducer as experienceReducer } from './experience';
import { reducer as academicReducer } from './academic';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    reposReducer,
    skillsReducer,
    messageReducer,
    loaderReducer,
    experienceReducer,
    academicReducer,
  });
